













































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import ReportsCompanyPicker from './ReportsCompanyPicker.vue';
import {
    downloadArrayBuffer,
    EventBus,
    getCurrentTimestamp,
    getIdsFromList,
    getLastMonthDates,
    TypeEventBus,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, AvailableVehiclesList, RadioOptions, RadioOption, DownloadReportsExcel, dateTypes, UserCompaniesReports } from '../../../features/core/models/';
import { ReportsServices } from '../api/ReportsServices';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SimpleTable,
        SectionTitle,
        MultipleSelect,
        ReportsCompanyPicker,
        DatePickerRange
    }
})
export default class ModalDownloadExcel extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: null}) suscriptionData: SuscriptionsList;
    modalTitle: string = "Descargar reporte a Excel";
    submitName: string = 'Descargar Excel';
    errorMsg: string = '';
    dateRangeSelected: Array<string> = [];
    generatingExcel: boolean = false;
    pendingAction: boolean = false;
    checkedCompanies: Array<UserCompaniesReports> = [];


    showUserPreferences(){
        EventBus.$emit(TypeEventBus.SHOW_USER_PREFERENCES);
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    updateRangeDate(value) {
       this.dateRangeSelected = [];
       this.dateRangeSelected = value;
     }


    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg, timeout){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: timeout
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg, timeout){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg,
            timeout: timeout
        });
    }

   

    submitAction() {
        this.generateExcel();
    }


    getData(){
        let companyIds = getIdsFromList(this.checkedCompanies);
        let templateName = this.suscriptionData.template.template_name
        return {
            date_from: this.dateRangeSelected[0],
            date_to: this.dateRangeSelected[1],
            company_ids: companyIds,
            template_name : templateName
        }
    }


    generateExcel(){
        let data = this.getData();
        let templateName = this.suscriptionData.template.template_name.replace(/\s+/g, '_').toLowerCase()
        let fileName = `reporte_${templateName}_${getCurrentTimestamp(dateTypes.dateFormatFromDisplayInfoHyphenMinsAndSeconds)}`;
        this.generatingExcel = true;
        ReportsServices.downloadExcel(
            data,
        ).then((res) => {
            this.generatingExcel = false;
            downloadArrayBuffer(fileName, res); 
            this.handleSuccessAction(res, 'Reporte descargado con éxito', 5000)
        }).catch((err) => {
            this.generatingExcel = false;
            this.handleErrorAction(err, 'No se pudo generar el excel', 5000);
        })
    }

    get datePickerEl(): HTMLFormElement {
        return this.$refs.datepickrangeexcel as HTMLFormElement;
    }

    get dateRangeIsValid() {
        return this.dateRangeSelected.length === 2 && this.dateRangeSelected.indexOf('') === -1;
    }
  



    get formIsValid() {
       
        if(
            this.dateRangeSelected.length !== 2 || 
            this.dateRangeSelected.indexOf('') !== -1
        ){
            this.setErrorForm('Debe especificar Fecha de Inicio y Fin')
            return false
        }

        if(!this.datePickerEl.rangeSelectedIsValid){
            this.setErrorForm('Revise las fechas')
            return false
        }

        if(this.checkedCompanies.length === 0){
            this.setErrorForm('No hay empresas marcadas')
            return false;
        }

        this.setErrorForm('');
        return true;
    }

    resetFields(){
        this.setErrorForm('');
    }

    @Emit()
    closeModal() {
        this.resetFields();
    }

    loadInfo(){
        this.updateRangeDate(getLastMonthDates())
    }

    mounted() {
        this.$nextTick(() => {
            this.loadInfo();
        });
    }
}
